import SolutionList from './SolutionList';
import SolutionShow from './SolutionShow';

export default {
  list: SolutionList,
  show: SolutionShow,
};
